import { parseDomain } from '../../utils';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const isVoucherSupported = async _ref => {
  let httpClient = _ref.httpClient,
    domain = _ref.request.domain;
  const parsedDomain = parseDomain(domain);
  const requestedTld = (domain == null ? void 0 : domain.tld) ?? parsedDomain.tld;
  const _await$dynamicLoadApi = await dynamicLoadApiQueries(httpClient),
    checkDomainAvailability = _await$dynamicLoadApi.checkDomainAvailability,
    domainTlds = _await$dynamicLoadApi.domainTlds,
    listEligibleCoupons = _await$dynamicLoadApi.listEligibleCoupons;
  const _await$Promise$all = await Promise.all([domainTlds({}), listEligibleCoupons({}), checkDomainAvailability({
      domain: parsedDomain.asciiDomain
    })]),
    tlds = _await$Promise$all[0].tlds,
    coupons = _await$Promise$all[1].coupons,
    availability = _await$Promise$all[2].availability;
  const tldData = tlds.find(_ref2 => {
    let tld = _ref2.tld;
    return tld === requestedTld;
  });
  const isPremium = !!(availability != null && availability.premium);
  const isVoucherSupportedTld = (tldData == null ? void 0 : tldData.couponsApplicable) && !isPremium;
  return {
    isVoucherSupported: !!isVoucherSupportedTld,
    hasValidVouchers: !!(coupons != null && coupons.length)
  };
};
//# sourceMappingURL=isVoucherSupported.js.map